import { CUSTOMER_JOURNEY_LOGIN, CUSTOMER_JOURNEY_LOGIN_SUCCESS, CUSTOMER_JOURNEY_LOGIN_ERROR } from './../../actions/const';
import { CUSTOMER_JOURNEY_LOGIN_RESERVATION, CUSTOMER_JOURNEY_LOGIN_RESERVATION_SUCCESS, CUSTOMER_JOURNEY_LOGIN_RESERVATION_ERROR } from './../../actions/const';

import CustomerJourneySource from './../../sources/CustomerJourneySource';

import defer from 'lodash/defer';

const initialState = {
  loading: false
};

function reducer(state = initialState, action) {
  const nextState = Object.assign({}, state);

  switch (action.type) {
    case CUSTOMER_JOURNEY_LOGIN: {
      nextState.loading = true;
      CustomerJourneySource.login(action.reservationId, action.surname, action.lang, action.successCallback, action.errorCallback);
      return nextState;
    }
    case CUSTOMER_JOURNEY_LOGIN_SUCCESS: {
      nextState.loading = false;
      if(action.successCallback) defer(action.successCallback, action.data);
      return nextState;
    }
    case CUSTOMER_JOURNEY_LOGIN_ERROR: {
      nextState.loading = false;
      if(action.errorCallback) defer(action.errorCallback);
      return nextState;
    }

    case CUSTOMER_JOURNEY_LOGIN_RESERVATION: {
      nextState.loading = true;
      CustomerJourneySource.loginReservation(action.checkInDate, action.checkOutDate, action.token, action.surname, action.lang, action.successCallback, action.errorCallback, action.context);
      return nextState;
    }
    case CUSTOMER_JOURNEY_LOGIN_RESERVATION_SUCCESS: {
      nextState.loading = false;
      if(action.successCallback) defer(action.successCallback, action.data);
      return nextState;
    }
    case CUSTOMER_JOURNEY_LOGIN_RESERVATION_ERROR: {
      nextState.loading = false;
      if(action.errorCallback) defer(action.errorCallback);
      return nextState;
    }

    default: {
      return state;
    }
  }
}

module.exports = reducer;



// WEBPACK FOOTER //
// ./reducers/customerJourney/login.js